import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("cy:bg-accent cy:animate-pulse cy:rounded-md", className)}
      {...props}
    />
  )
}

export { Skeleton }
